<template>
    <div class="main_container">
        <div class="search-box" id="searchBox">
            <div @click="showMore" class="showMoreBtn">
                <i class="iconfont icon-you" v-bind:class="{'icon-shang': isShowMore}"></i>
                <span>{{$t('message.Search')}}</span>
            </div>
            <div v-show="isShowMore">
                <el-form :label-width="labelW" :model="ruleForm" ref="ruleForm">
                    <el-form-item :label="$t('message.KeyWord')" prop="SearchKey">
                        <el-input placeholder=" "
                                  v-model="ruleForm.SearchKey"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.InvoiceType')" prop="InvoiceTypeCode">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.InvoiceTypeCode">
                            <el-option
                                    :key="index"
                                    :label="item.TypeDesc"
                                    :value="item.TypeCode"
                                    v-for="(item, index) in invoiceTypeOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('message.InvoiceDate')" prop="InvoiceDate">
                        <el-date-picker
                                end-placeholder=" "
                                range-separator="-"
                                start-placeholder=" "
                                type="daterange"
                                v-model="ruleForm.InvoiceDate"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('message.IsEdit')" prop="IsEdit">
                        <el-radio-group v-model="ruleForm.IsEdit">
                            <el-radio :label="1">{{$t('message.Yes')}}</el-radio>
                            <el-radio :label="0">{{$t('message.No')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('message.Amount')" prop="Amount">
                        <div class="amount">
                            <el-input placeholder=" "
                                      type="number"
                                      v-model="ruleForm.Amount.AmountStart"></el-input>
                            <span>~</span>
                            <el-input placeholder=" "
                                      type="number"
                                      v-model="ruleForm.Amount.AmountEnd"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('message.SortFlag')" prop="SortFlag">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.SortFlag">
                            <el-option
                                    :key="index"
                                    :label="$t('message.' + item.name)"
                                    :value="item.value"
                                    v-for="(item, index) in sortFlagOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="'发票状态'" prop="InvoiceStatus">
                        <el-select filterable placeholder=" "
                                   v-model="ruleForm.InvoiceStatus">
                            <el-option
                                    :key="index"
                                    :label="item.Description"
                                    :value="item.Status"
                                    v-for="(item, index) in InvoiceStatusOptions">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="button-line">
                        <el-form-item>
                            <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                                <el-button @click="submitForm('ruleForm')" class="icon iconfont icon-sousuo"
                                           type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip :content="$t('message.Reset')" class="item" effect="dark" placement="top">
                                <el-button @click="resetForm('ruleForm')"
                                           class="icon iconfont icon-zhongzhi"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="table_container" v-loading="isLoading">
            <el-button-group>
                <el-tooltip :content="$t('message.Add')" class="item" effect="dark" placement="top">
                    <el-button @click="handleAdd" class="icon iconfont icon-xinzeng-wubiankuang"
                               type="primary"></el-button>
                </el-tooltip>
            </el-button-group>
            <el-table
                    :data="tableData"
                    :header-cell-style="{'background-color': '#f8f8f9', 'color': '#262626'}"
                    :height="tableHeight"
                    :max-height="tableHeight"
                    :row-key="row => row.index"
                    class="table_list table_border"
                    ref="multipleTable"
                    stripe>
                <el-table-column
                        :label="$t('message.ConsumptionKind')"
                        :min-width="tableW[0]"
                        prop="ConsumptionKind"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceType')"
                        :min-width="tableW[1]"
                        :show-overflow-tooltip="true"
                        prop="TypeDesc"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceRemarks')"
                        :min-width="tableW[2]"
                        :show-overflow-tooltip="true"
                        prop="InvoiceRemarks"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.BusinessName')"
                        :min-width="tableW[3]"
                        :show-overflow-tooltip="true"
                        prop="BusinessName"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceDate')"
                        :min-width="tableW[4]"
                        prop="BeginTime"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.IsEdit')"
                        :min-width="tableW[5]"
                        prop="IsChanged"
                        sortable>
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.IsChanged === 0 ? $t('message.No') : $t('message.Yes')}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('message.IsVerification')"
                        :min-width="tableW[6]"
                        prop="IsCheckTrueStr"
                        sortable>
                </el-table-column>
                <el-table-column
                        :label="$t('message.InvoiceStatus')"
                        :min-width="tableW[7]"
                        prop="InvoiceStatus"
                        sortable>
                    <template slot-scope="scope">
                        <span :class="{waite: scope.row.InvoiceStatus === 1}">
                            {{scope.row.InvoiceStatusDesc}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('message.Amount')"
                        :width="tableW[8]"
                        align="right"
                        prop="TotalAmount"
                        sortable>
                </el-table-column>
                <el-table-column :label="$t('message.Operating')" width="90">
                    <template slot-scope="scope">
                        <el-tooltip
                                :content="$t('message.View')"
                                class="item"
                                effect="dark"
                                placement="top"
                        >
                            <el-button
                                    @click="handleEdit(scope.row)"
                                    class="hoverBtn iconfont icon-chakan"
                                    v-if="scope.row.CanEdit === 0"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                                :content="$t('message.Edit')"
                                class="item"
                                effect="dark"
                                placement="top"
                        >
                            <el-button
                                    @click="handleEdit(scope.row)"
                                    class="hoverBtn iconfont icon-bianji-kong"
                                    v-if="scope.row.CanEdit === 1"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                                :content="$t('message.Delete')"
                                class="item"
                                effect="dark"
                                placement="top">
                            <el-button
                                    @click="handleDelete(scope.row.Id)"
                                    class="hoverBtn iconfont icon-shanchu-kong"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :total="count"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        background
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :element-loading-text="loadingText"
                :title="$t('message.UploadInvoice')"
                :visible.sync="dialogVisible"
                class="new_dialog"
                v-loading="ocrLoading"
                width="400px">
            <el-upload
                    :action="baseUrl + 'api/InvoiceNew/UploadInvoice'"
                    :headers="headers"
                    :auto-upload="true"
                    :before-upload="beforeUpload"
                    :limit="1"
                    :on-error="handleError"
                    :on-progress="handleProgress"
                    :on-success="handleSuccess"
                    drag
                    ref="upload">
                <i class="iconfont icon-shangchuan-kong upload_icon"></i>
                <div class="el-upload__text">{{$t('message.UploadTips')}}<br><span>{{$t('message.UploadAccept')}}</span>
                </div>
            </el-upload>
            <div class="upload_list" v-if="showUploadList">
                <div class="file_title ellipsis">
                    <span>{{uploadInfo.name}}</span>
                    <el-progress :percentage="uploadInfo.percentage" v-if="showProgress"></el-progress>
                </div>
                <el-tooltip :content="$t('message.Delete')" class="item" effect="dark" placement="top">
                    <el-button @click="handleRemove" class="del_upload iconfont icon-shanchu-kong"></el-button>
                </el-tooltip>
            </div>
            <span class="dialog-footer" slot="footer">
                <el-tooltip :content="$t('message.Cancel')" class="item" effect="dark" placement="top">
                    <el-button @click="dialogVisible = false" class="iconfont icon-guanbi-wukuang"></el-button>
                </el-tooltip>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseUrl} from "../config/env";
    import {GetInvoiceType, GetInvoiceList, DelInvoice, ReadInvoiceFile,GetInvoiceStatus} from "../api/apiInvoice";
    import {setStore, removeStore, getLocal, setGuid} from "../config/mUtils";

    export default {
        name: 'myInvoice',
        data() {
            return {
                headers: {
                    Authorization: 'Bearer ' + (getLocal('accessToken') || '')
                },
                baseUrl,
                labelW: 0 + 'px',
                isShowMore: false,
                invoiceTypeOptions: [],
                InvoiceStatusOptions:[],
                sortFlagOptions: [
                    {name: 'SortFlag1', value: '1'},
                    {name: 'SortFlag2', value: '2'},
                    {name: 'SortFlag3', value: '3'},
                    {name: 'SortFlag4', value: '4'},
                    {name: 'SortFlag5', value: '5'},
                    {name: 'SortFlag6', value: '6'}
                ],
                ruleForm: {
                    SearchKey: '',
                    InvoiceTypeCode: '0',
                    InvoiceDate: ['', ''],
                    IsEdit: '-1',
                    Amount: {
                        AmountStart: '',
                        AmountEnd: ''
                    },
                    SortFlag: '1',
                    InvoiceStatus:''
                },
                tableHeight: 0,
                isLoading: false,
                tableData: [],
                offset: 1,
                limit: 10,
                count: 0,
                currentPage: 1,
                normalW: {
                    cn: ['95', '110', '200', '160', '140', '70', '70', '70', '100'],
                    en: ['160', '125', '200', '160', '140', '100', '95', '85', '100']
                },
                tableW: [],
                showUploadList: false,
                showProgress: false,
                uploadInfo: {},
                dialogVisible: false,
                loadingText: '',
                ocrLoading: false
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.watchHeight();
            this.initData();
            this.resetLabelWidth();
            removeStore('OCRData');
            removeStore('changedInvoiceIndexData');
        },
        mounted() {
            setTimeout(() => {
                let widowHeight = document.documentElement.clientHeight - 275;
                let h = document.getElementById('searchBox').clientHeight;
                this.tableHeight = widowHeight - h;
            }, 1);
        },
        computed: {
            canResetH() {
                return this.isShowMore;
            },
            langChange() {
                return this.$i18n.locale;
            }
        },
        watch: {
            canResetH() {
                setTimeout(() => {
                    let widowHeight = document.documentElement.clientHeight - 275;
                    let h = document.getElementById('searchBox').clientHeight;
                    this.tableHeight = widowHeight - h;
                }, 1);
            },
            langChange(val) {
                if (val) {
                    this.isShowMore = false;
                    this.resetLabelWidth();
                    setTimeout(() => {
                        let widowHeight = document.documentElement.clientHeight - 275;
                        let h = document.getElementById('searchBox').clientHeight;
                        this.tableHeight = widowHeight - h;
                    }, 1);
                }
            }
        },
        methods: {
            watchHeight() {
                setTimeout(() => {
                    const that = this;
                    window.onresize = function temp() {
                        let widowHeight = document.documentElement.clientHeight - 275;
                        let h = document.getElementById('searchBox').clientHeight;
                        that.tableHeight = widowHeight - h;
                    };
                }, 1);
            },
            resetLabelWidth() {
                if (getLocal('language') === 'zh-CN') {
                    this.labelW = 100 + 'px';
                    this.tableW = this.normalW.cn;
                } else {
                    this.labelW = 100 + 'px';
                    this.tableW = this.normalW.en;
                }
            },
            showMore() {
                this.isShowMore = !this.isShowMore;
            },
            async initData() {
                try {
                    this.getInvoiceType();
                    this.getInvoiceList();
                } catch (err) {
                    console.log(err);
                }
            },
            // 获取发票类型
            async getInvoiceType() {
                this.invoiceTypeOptions = [];
                try {
                    let data = await GetInvoiceType(
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.invoiceTypeOptions = data.data;
                    }
                    let data1 = await GetInvoiceStatus(
                        // getLocal('language')
                    );
                    if (data1.error_code === '0') {
                        this.InvoiceStatusOptions = data1.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 获取我的发票列表
            async getInvoiceList() {
                this.isLoading = true;
                this.tableData = [];
                try {
                    let data = await GetInvoiceList(
                        getLocal('ADAccount'),
                        "",
                        this.ruleForm.SearchKey,
                        parseInt(this.ruleForm.InvoiceTypeCode),
                        this.ruleForm.Amount.AmountStart !== '' ? this.ruleForm.Amount.AmountStart : -1,
                        this.ruleForm.Amount.AmountEnd !== '' ? this.ruleForm.Amount.AmountEnd : -1,
                        this.ruleForm.InvoiceDate[0],
                        this.ruleForm.InvoiceDate[1],
                        parseInt(this.ruleForm.IsEdit),
                        this.ruleForm.InvoiceStatus,
                        this.ruleForm.SortFlag,
                        this.offset,
                        this.limit,
                        getLocal('language'),
                        getLocal('CompanyCode'),
                        getLocal('BossAgentUserCode'),                        
                    );
                    if (data.error_code === '0') {
                        this.isLoading = false;
                        this.count = data.data.TotalCount;
                        data.data.returnList.forEach(ele => {
                            ele.BusinessName = ele.SellerName;
                            ele.BeginTime = ele.InvoiceDateStr;
                            this.tableData.push(ele);
                        });
                    } else {
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 更改每页显示数据条数
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.offset = 1;
                this.getInvoiceList();
            },
            // 更改当前页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.offset = val;
                this.getInvoiceList();
            },
            // 搜索
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getInvoiceList();
                    } else {
                        return false;
                    }
                });
            },
            // 重置
            resetForm(formName) {
                this.ruleForm.CreateTime = ['', ''];
                this.$refs[formName].resetFields();
                this.offset = 0;
                this.currentPage = 1;
                this.getInvoiceList();
            },
            // 新增
            handleAdd() {
                this.dialogVisible = true;
                this.showUploadList = false;
                this.uploadInfo = {};
            },
            // 上传前验证
            beforeUpload(file) {
                removeStore('OCRData');
                var fileStyle = (file.name.substring(file.name.lastIndexOf(".") + 1)).toLowerCase();
                //只允许上传*.jpg,*.jpeg,*.png,*.gif,*.pdf,*.ofd文件
                var isRightStyle = /(jpg|jpeg|png|gif|pdf|ofd)$/.test(fileStyle);
                if (!isRightStyle) {
                    this.$message.error(this.$t('message.UploadAcceptOnly'));
                    return false;
                } else {
                    return isRightStyle;
                }
            },
            // 上传中
            handleProgress(event, file) {
                this.ocrLoading = true;
                this.loadingText = this.$t('message.Uploading');
                this.showUploadList = true;
                this.uploadInfo = file;
                if (event.percent !== 100) {
                    this.showProgress = true;
                } else {
                    setTimeout(() => {
                        this.showProgress = false;
                    }, 500);
                }
            },
            // 上传成功
            handleSuccess(res) {
                if (res.error_code === '0') {
                    this.$message.success(this.$t('message.UploadSuccessful'));
                    this.loadingText = this.$t('message.WaitOCRRead');
                    this.readInvoiceFile(res.data.Id);
                } else if (res.error_code === '100003') {
                    this.$message.error(res.message);
                    this.showUploadList = false;
                    this.uploadInfo = {};
                    this.$refs.upload.clearFiles();
                    this.ocrLoading = false;
                } else {
                    this.$message.error(this.$t('message.UploadFailed'));
                    this.showUploadList = false;
                    this.uploadInfo = {};
                    this.$refs.upload.clearFiles();
                    this.ocrLoading = false;
                }
            },
            // 上传失败
            handleError() {
                this.$message.error(this.$t('message.UploadFailed'));
                this.showUploadList = false;
                this.uploadInfo = {};
                this.$refs.upload.clearFiles();
            },
            // 删除上传
            handleRemove() {
                this.$confirm(this.$t('message.ConfirmDelete'), this.$t('message.Tips'), {
                    confirmButtonText: ' ',
                    cancelButtonText: ' ',
                    confirmButtonClass: 'icon iconfont icon-gou-wukuang',
                    cancelButtonClass: 'icon iconfont icon-guanbi-wukuang',
                    type: "warning"
                }).then(() => {
                    this.showUploadList = false;
                    this.uploadInfo = {};
                    this.$refs.upload.clearFiles();
                }).catch(() => {
                    this.$message.info(this.$t('message.CancelSubmit'));
                });
            },
            // OCR读取发票文件
            async readInvoiceFile(Id) {
                try {
                    let data = await ReadInvoiceFile(
                        getLocal('ADAccount'),
                        Id,
                        3,
                        getLocal('language'),
                        getLocal('CompanyCode'),
                        getLocal('BossAgentUserCode')
                    );
                    if (data.error_code === '0') {
                        this.$message.success(this.$t('message.OCRReadSuccessfully'));
                        this.ocrLoading = false;
                        setStore('OCRData', data.data);
                        this.$router.push("/myInvoiceDetail");
                    } else {
                        this.$message.error(data.message);
                        this.showUploadList = false;
                        this.uploadInfo = {};
                        this.$refs.upload.clearFiles();
                        this.ocrLoading = false;
                        this.isLoading = false;
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 进入编辑详情
            handleEdit(row) {
                removeStore('OCRData');
                if (row.CanEdit === 1) {
                    this.$router.push("/myInvoiceDetail?Id=" + row.Id);
                } else {
                    this.$router.push("/myInvoiceDetail?Id=" + row.Id + '&IsEdit=' + setGuid());
                }
            },
            // 删除发票
            async delInvoice(Id) {
                try {
                    let data = await DelInvoice(
                        Id,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.$message.success(this.$t('message.DeleteSuccessful'));
                        this.offset = 1;
                        this.currentPage = 1;
                        this.getInvoiceList();
                    } else {
                        this.$message.error(data.message);
                    }
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            },
            // 删除
            handleDelete(Id) {
                this.$confirm(this.$t('message.ConfirmDelete'), this.$t('message.Tips'), {
                    confirmButtonText: ' ',
                    cancelButtonText: ' ',
                    confirmButtonClass: 'icon iconfont icon-gou-wukuang',
                    cancelButtonClass: 'icon iconfont icon-guanbi-wukuang',
                    type: "warning"
                }).then(() => {
                    this.delInvoice(Id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>
